import React from "react"

export default function Header() {
    return (
        <header className="shadow sticky z-50 top-0" style={{ display: "none" }}>Not Found</header>
    );
}